import AppHeader from "../../../components/AppHeader";
import { images } from "../constants";
import { withImageFallback } from "../utils";

export default function HeaderSection() {
  return (
    <AppHeader
      logoSrc={images.landingLogo}
      logoAlt="SMAUL"
      logoWidth={110}
      copy="売却相談ならスマウル"
      onLogoError={withImageFallback(["/src/assets/images/smaul_logo.png"])}
    />
  );
}
